import { useQuery } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService';
import type { AuthUserOnboardingStatus } from '@Store/slices/authOnboarding/authOnboarding.types';
import type { DocVStatus } from '@Store/slices/ubo/createUboSlice';

export interface ResendAuthUserDocVResponse {
  authorizedUserId: string;
  onboardingStatus: AuthUserOnboardingStatus;
  docVStatus: DocVStatus;
  docVUrl?: string;
  qrCode?: string;
}

export const resendAuthUserDocV = async (
  customerId: string,
  authorizedUserId: string
): Promise<ResendAuthUserDocVResponse> => {
  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/resend-docv`;
  const { data } = await HttpService.post<ResendAuthUserDocVResponse>(url, {});
  return data;
};

export const useResendAuthUserDocV = (customerId: string, authorizedUserId: string) =>
  useQuery({
    queryFn: () => resendAuthUserDocV(customerId, authorizedUserId),
    queryKey: ['resendAuthUserDocV', customerId, authorizedUserId],
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
